import styled from "styled-components"
import { TextareaField } from "../../../../commerce/address-form/form-fields.component"
import {
  BasicButtonLink,
  TextLink,
} from "../../../../../ui/components/link/link.component"
import { FullSection } from "../../section.component"
import { BasicFullButton } from "../../../../../ui/components/button/button.component"
import { ErrorMessage } from "../../../general-styles.component"

export const FormBody = styled.div<{ active?: boolean }>`
  transition: all 0.3s ease-in-out;
  opacity: ${(p) => (p.active ? 1 : 0)};
  visibility: ${(p) => (p.active ? "visible" : "hidden")};
  max-height: ${(p) => (p.active ? "5000px" : 0)};
  overflow: hidden;
`

export const Form = styled.form`
  margin-top: 90px;
  width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    width: 305px;
  }
`

export const FieldWrapper = styled.div`
  margin-bottom: 50px;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    margin-bottom: 100px;
  }

  > * {
    align-items: center;
    justify-content: center;
  }

  &:first-child {
    margin-top: 90px;

    @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
      margin-top: 140px;
    }
  }

  &:last-child {
    margin-bottom: 120px;
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
  padding-bottom: 90px;
  background-color: ${({ theme }) => theme.color.backgroundInverted};

  p {
    text-align: left;
  }

  h2 {
    margin-bottom: 15px;
  }

  ${TextLink} {
    padding-top: 30px;
  }

  ${BasicButtonLink} {
    margin-top: 50px;
  }

  ${BasicFullButton} {
    max-width: 560px;
    margin-top: 50px;
    align-self: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    padding: 50px 15px;
  }
`

export const FullSectionWrapper = styled(FullSection)`
  padding-top: 90px;
  padding-bottom: 80px;
  background-color: ${({ theme }) => theme.color.backgroundAttentionLight};
`

export const FieldNumber = styled.span`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.backgroundAttention};
  line-height: 37px;
  font-size: ${23 / 16}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -80px;
  top: 0px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    top: -55px;
    left: 0px;
  }
`

export const FieldQuestion = styled.div`
  width: 560px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    min-width: 305px;
    width: 100%;
  }
`

export const FieldQAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
`

export const QuestionLabelWrapper = styled.p`
  font-family: "Lato", sans-serif;
  font-weight: 500;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    font-size: ${14 / 16}rem;
  }
`

export const SublabelWrapper = styled.span`
  color: #737373;
  font-size: 12px;
  font-style: italic;
  line-height: 20px;
`

export const MaxCharWrapper = styled.span<{ error?: string }>`
  color: ${({ error, theme }) => (error ? theme.color.error : "#737373")};
  font-size: 12px;
  line-height: 20px;
  font-style: normal;
  align-self: flex-end;
`

export const TextareaFieldWrapper = styled(TextareaField)`
  textarea {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 2px;
  }
`

export const InputsWrapper = styled.div`
  display: grid;
  grid-template-columns: 108px auto;
  grid-template-rows: 90px;
  grid-row-gap: 5px;
  grid-template-areas: "Label Input" ". Error";
  border-radius: 2px;
  margin-bottom: 5px;

  p {
    grid-area: Error;
  }

  &:last-child {
    margin-bottom: 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    grid-row-gap: 0;
    grid-template-areas: "Label" "Input" "Error";
    grid-template-columns: auto;
    grid-template-rows: 40px 120px auto;
  }
`
export const TextareaSublabelWrapper = styled(TextareaField)`
  textarea {
    height: 100%;
    padding: 15px 30px;
  }
`

export const InputSublabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.backgroundSuperLight};
  border: 1px solid ${({ theme }) => theme.color.commerceBorder};
  border-right: none;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    border-right: 1px solid ${({ theme }) => theme.color.commerceBorder};
    border-bottom: none;
    justify-content: flex-start;
    padding-left: 15px;
  }
`

export const ContactInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > * {
    margin: 0 0 30px 0;
    width: 100%;
  }

  > :first-child {
    margin-top: 70px;
    margin-bottom: 50px;

    @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
      margin-top: 0;
    }
  }

  > :last-child {
    margin-bottom: 0;
  }

  width: 560px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    width: 100%;
  }
`

export const Error = styled(ErrorMessage)`
  margin-top: 30px;
  max-width: 455px;
  text-align: center !important;
  font-weight: normal;
`
